import { render, staticRenderFns } from "./ThreeColumnTable.vue?vue&type=template&id=03221370&"
import script from "./ThreeColumnTable.vue?vue&type=script&lang=js&"
export * from "./ThreeColumnTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports